const state = {
  currentOnboardingStep: 'mfa',
}

/** 
 * @type {import('vuex').GetterTree<typeof state>} 
 */
const getters = {
  
}

/** 
 * @type {import('vuex').ActionTree<typeof state>} 
 */
const actions = {
  setCurrentOnboardingStep({ commit }, step) {
    commit('SET_CURRENT_ONBOARDING_STEP', step)
  }
}

/** 
 * @type {import('vuex').MutationTree<typeof state>} 
 */
const mutations = {
  SET_CURRENT_ONBOARDING_STEP(state, step) {
    state.currentOnboardingStep = step
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}